import { NgxSpinnerService } from "ngx-spinner";
import { NgxIndexedDBService } from "ngx-indexed-db";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { ICMetaDescription } from "../models/entities/icmetadescription";
import { ICMetaDescriptionFilter } from "../models/filters/icmetadescription.filter";
import { ICMetaDescriptionApi } from "../models/apis/icmetadescription.api";
import { BaseDataService } from "./shared/base.data.service";

@Injectable()
export class ICMetaDescriptionService extends BaseDataService<
  ICMetaDescription,
  ICMetaDescriptionFilter,
  ICMetaDescriptionApi
> {
  constructor(
    public dbSrv: NgxIndexedDBService,
    public spinner: NgxSpinnerService,
    public http: HttpClient,
  ) {
    super(dbSrv, spinner, http, ICMetaDescription);
    this.EndPoint = "icmetadescription";
  }
}
